
export const TC_SELECT_PREFIX = 'tc-select';

export const themeSelect = (theme: any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: '#FF8C24',
    primary75: '#FF9E3E',
    primary50: '#FFB86B',
    primary25: 'rgba(255, 140, 36, 0.12)',
  },
});

export const styleSelect = {
  placeholder: (provided: any) => ({
    ...provided,
    color: 'var(--tc-text-muted)',
  }),
  indicatorSeparator: (provided: any) => ({
    ...provided,
    display: 'none',
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: 'var(--tc-primary)',
  }),
  clearIndicator: (provided: any) => ({
    ...provided,
    color: 'var(--tc-text-muted)',
    ':hover': { color: 'var(--tc-primary)' },
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    border: `1px solid ${state.isFocused ? 'var(--tc-primary)' : 'var(--tc-border)'}`,
    borderRadius: '6px',
    padding: '3px',
    fontSize: '1rem',
    boxShadow: state.isFocused ? '0 0 0 1px var(--tc-primary)' : 'none',
    backgroundColor: state.isDisabled ? 'var(--tc-bg-raised)' : 'var(--tc-input-bg)',
    color: 'var(--tc-text)',
    outline: '0',
  }),
  singleValue: (provided: any, state: any) => ({
    ...provided,
    color: state.isDisabled ? 'var(--tc-text-muted)' : 'var(--tc-text)',
    fontWeight: 500,
  }),
  input: (provided: any) => ({
    ...provided,
    color: 'var(--tc-text)',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    color: state.data.value === 'new' ? 'var(--tc-primary)' : 'var(--tc-text)',
    backgroundColor: state.isSelected
      ? 'var(--tc-primary)'
      : state.isFocused
      ? 'var(--tc-bg-raised)'
      : 'var(--tc-bg-surface)',
  }),
  menu: (provided: any) => ({
    ...provided,
    backgroundColor: 'var(--tc-bg-surface)',
    border: '1px solid var(--tc-border)',
    boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
    zIndex: 999,
  }),
  menuList: (provided: any) => ({
    ...provided,
    backgroundColor: 'var(--tc-bg-surface)',
  }),
  multiValue: (provided: any) => ({
    ...provided,
    backgroundColor: 'var(--tc-bg-raised)',
  }),
  multiValueLabel: (provided: any) => ({
    ...provided,
    color: 'var(--tc-text)',
  }),
  multiValueRemove: (provided: any) => ({
    ...provided,
    color: 'var(--tc-text-muted)',
    ':hover': {
      backgroundColor: '#F1416C',
      color: 'white',
    },
  }),
};
